import { TableCell, TableRow } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { ModuleExamDetailsViewModel } from "../../../../model/ExamSignup/ModuleExamDetailsViewModel";
import {
  ModuleSelectionExamDetails,
  ModuleSelectionViewModel,
} from "../../../../model/ExamSignup/ModuleSelectionViewModel";
import { GetTranslatedValueIntl } from "../../../../model/Shared/TranslatedValue";
import { useSignUpContext } from "../../CertificationDataWizardContext/CertificationDataWizardContext";
import ExamLocationAndDateStepRowExam from "./ExamLocationAndDateStepRowExam";
import { Language } from "../../../../data/constants";
import { ArrayHelper } from '../../../../utils/ArrayHelper';

type ExamLocationAndDateStepRowProps = {
  module: ModuleSelectionViewModel;
  updateModuleSelection: (selection: ModuleSelectionViewModel) => void;
  allExamPossibleDetails: ModuleExamDetailsViewModel[];
};

const ExamLocationAndDateStepRow: React.FunctionComponent<ExamLocationAndDateStepRowProps> = ({
  module,
  updateModuleSelection,
  allExamPossibleDetails,
}) => {
  const { referenceModules } = useSignUpContext();
  const intl = useIntl();

  const availableExamDetails = allExamPossibleDetails.filter((e) => e.moduleId === module.moduleId && e.examSessionId === module.examSessionId);

  const availableLanguages = availableExamDetails.reduce((languageList: Language[], e) => {
    if (e.availableLocations.length > 0){
      languageList = ArrayHelper.addIfNotExists(languageList, e.language as Language);
    }
    return languageList;
  }, []);

  const [language, setLanguage] = React.useState<Language | undefined>(undefined);

  const referenceModule = referenceModules.find(
    (m) => m.courseId === module.courseId && m.id === module.moduleId && m.examSessionId === module.examSessionId
  );

  if (!referenceModule) {
    console.error(
      `Could not find reference module with Course id ${module.courseId}, ExamSessionid ${module.examSessionId} and Module id ${module.moduleId}`
    );
    return null;
  }

  const updateExamDetails = (examDetails: ModuleSelectionExamDetails) => {
    updateModuleSelection({
      ...module,
      details: { ...module.details },
      examDetails: [...(module.examDetails ?? []).filter((e) => e.examId !== examDetails.examId), examDetails],
    });
  };

  const handleLanguageChange = (newLanguage: Language, examId: string) => {
    setLanguage(newLanguage);
  };

  const possibleExamDetails = (referenceExamId: string, language: Language) =>
    availableExamDetails.find(
      (l) =>
        l.courseId === module.courseId &&
        l.examSessionId === module.examSessionId &&
        l.moduleId === module.moduleId &&
        l.examId === referenceExamId &&
        l.language === language
    );

  return (
    <>
      <TableRow>
        <TableCell component="th" scope="row" colSpan={6} style={{ fontWeight: "bold" }}>
          {GetTranslatedValueIntl(intl, referenceModule.name)}
        </TableCell>
      </TableRow>
      {referenceModule.exams.map((referenceExam) => {
        const details = module.examDetails?.find((e) => e.examId === referenceExam.id);
        return (
          <ExamLocationAndDateStepRowExam
            key={referenceExam.id}
            referenceExam={referenceExam}
            selectedLocationId={details?.locationId}
            selectedExamDayId={details?.examDayId}
            selectedLanguage={(details?.language ?? availableLanguages[0]) as Language}
            examPossibleDetails={possibleExamDetails(referenceExam.id, (details?.language ?? language ) as Language)}
            updateExamDetails={updateExamDetails}
            onLanguageChange={handleLanguageChange}
            disabled={module.paid ?? false}
            availableLanguages={ArrayHelper.addIfNotExists(availableLanguages, details?.language as Language)}
            isLoading={!allExamPossibleDetails}
            paid={module?.paid ?? false}
          />
        );
      })}
    </>
  );
};

export default ExamLocationAndDateStepRow;
